import React, {Component} from 'react';
import {HashRouter as Router, Route} from 'react-router-dom';

import MainIndex from '../components/MainIndex';
import Auth from '../components/Auth';
import AddSAML from '../components/AddSAML';
import DeleteSAML from '../components/DeleteSAML';
import ListSAML from '../components/ListSAML';
import TestUI from '../components/TestUI';
import './App.scss';
import CustomizeGlobalIdpSettings
  from "../components/CustomizeGlobalIdpSettings";
import Logout from "../components/Logout";
import AddAzureAD from "../components/AddAzureAD";
import GetAzureAdList from "../components/AzureAdList";

class App extends Component {
  render() {
    return (
        <Router>
          <div className="App-container">
            <Route exact path="/" component={MainIndex}/>
            <Route path="/addsaml/:applicationId?" component={AddSAML}/>
            <Route path="/listsaml" component={ListSAML}/>
            <Route path="/deletesaml" component={DeleteSAML}/>
            <Route path="/auth" component={Auth}/>
            <Route path="/testui" component={TestUI}/>
            <Route path="/customization"
                   component={CustomizeGlobalIdpSettings}/>
            <Route path="/logout" component={Logout}/>
            <Route path="/addazuread" component={AddAzureAD}/>
            <Route path="/getazureadlist" component={GetAzureAdList}/>
          </div>
        </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js